import { RbTable, RbToolbarActionButton, RbToolbarActions, RbToolbarDateRangeField, RbToolbarMultiSelectField, RbToolbarSearchField, Tooltip } from '@scmlatam/web-ui';
import type { Row } from '../types/hooks';
import ToolbarSearchIcon from '../../../../assets/icons/toolbar-search-icon.svg';
import ToolbarMoreIcon from '../../../../assets/icons/toolbar-more-icon.svg';
import type { TableProps } from '../types/component';

const Table = (tableProps: TableProps) => {
    return (
        <RbTable<Row>
            className="w-full"
            toolbarRight={
                <>
                    <RbToolbarSearchField value={tableProps.filter} onChange={tableProps.setFilter} placeholder="Buscar..." />

                    <RbToolbarDateRangeField label={tableProps.t('filter.period')} value={tableProps.period} onChange={tableProps.setPeriod} />

                    <RbToolbarMultiSelectField
                        label={tableProps.t('filter.tags')}
                        placeholder={tableProps.t('filter.multi_select')}
                        value={tableProps.tagSelected}
                        onChange={(value) => {
                            tableProps.setTagSelected(value);
                        }}
                        options={tableProps.tags}
                        search={{
                            value: tableProps.searchTag,
                            onChange: tableProps.setSearchTag,
                            placeholder: tableProps.t('filter.search_tag'),
                        }}
                    />

                    <RbToolbarActions>
                        <Tooltip content={tableProps.t('tooltips.search')}>
                            <RbToolbarActionButton
                                variant="outlinedIcon"
                                disabled={!(tableProps.period[0]?.isValid() && tableProps.period[1]?.isValid() && tableProps.tags.length > 0) || tableProps.loading}
                                loading={tableProps.loading}
                                onClick={() => {
                                    tableProps.search(tableProps.period[0]?.format('YYYY-MM-DD') || '', tableProps.period[1]?.format('YYYY-MM-DD') || '', tableProps.tagSelected.join(','));
                                }}
                                icon={<img src={ToolbarSearchIcon} alt="toolbar-search-icon" style={{ width: '16px', height: '16px' }} />}
                            />
                        </Tooltip>

                        {tableProps.canOpenEmployeeActions && (
                            <Tooltip content={tableProps.t('tooltips.more_actions')}>
                                <RbToolbarActionButton
                                    variant="icon"
                                    disabled={!(tableProps.startDate && tableProps.endDate && tableProps.tagIds) || tableProps.loading}
                                    loading={tableProps.loading}
                                    onClick={(event) => {
                                        const rect = event.currentTarget.getBoundingClientRect();

                                        tableProps.setContextMenu({
                                            x: rect.left,
                                            y: rect.bottom + 6,
                                        });

                                        tableProps.setVariant('dark');
                                    }}
                                    icon={<img src={ToolbarMoreIcon} alt="toolbar-more-icon" style={{ width: '16px', height: '16px' }} />}
                                />
                            </Tooltip>
                        )}
                    </RbToolbarActions>
                </>
            }
            columns={tableProps.columns}
            rows={tableProps.rows}
            showToolbar={true}
            checkboxSelection={true}
            paginate={false}
            defaultRowsPerPage={200}
            emptyText={tableProps.t('table.no_rows')}
            rowSelectionModel={tableProps.rowSelected}
            setRowSelectionModel={tableProps.setRowSelected}
            loading={tableProps.loading}
            density="comfortable"
            size="l"
            onCellContextMenu={(params) => {
                tableProps.setRowId(params.row.id);
                tableProps.setOption(null);
                tableProps.setVariant('light');

                tableProps.setContextMenu({
                    x: params.position.x,
                    y: params.position.y,
                });
            }}
        />
    );
};

export { Table };
